export const environment = {
  production: false, 
  KEYCLOAK_SERVER_ADDR: 'https://dev-auth.pjm.gob.ar',
  KEYCLOAK_REALM: 'devops',
  KEYCLOAK_CLIENT_ID: 'spa',
  SERVER_FRONT_ADDR: 'https://dev-spa.pjm.gob.ar/',
  SERVER_FRONT_ADDR_ENCODED: 'https%3A%2F%2Fdev-spa.pjm.gob.ar%2F',
  SERVER_BACK_ADDR: 'https://dev-spa-backend.pjm.gob.ar/'
};
